export enum AccountingPeriodStatus {
  Open = 0,
  ClosedForRegistration = 1,
  ClosedForRegistrationAndInvoicing = 2,
  Closed = 3,
}

export enum AccountingPeriodType {
  Month = 'Month',
  Quarter = 'Quarter',
  Year = 'Year',
}

export interface AccountingPeriodDate {
  accountingPeriodDateId: number;
  accountingPeriodId: number;
  date: string;
  status: AccountingPeriodStatus;
}

export interface AccountingPeriod {
  accountingPeriodId: number;
  startDate: string;
  endDate: string;
  status: AccountingPeriodStatus;
  createdBy: number;
  lastModifiedBy: number;
  created: string | null;
  lastModified: string;
  accountingPeriodGuid: string;
  accountingPeriodDates: AccountingPeriodDate[];
}

export type AccountingPeriodsResponse = AccountingPeriod[];

export interface CreateAccountingPeriodRequest {
  startDate: string; // ISO date format (YYYY-MM-DD)
  endDate: string; // ISO date format (YYYY-MM-DD)
}

export interface UpdateAccountingPeriodRequest {
  startDate: string; // ISO date format (YYYY-MM-DD)
  endDate: string; // ISO date format (YYYY-MM-DD)
}

export interface UpdateAccountingPeriodStatusRequest {
  accountingPeriodId: number;
  startDate: string; // ISO date format (YYYY-MM-DD)
  endDate: string; // ISO date format (YYYY-MM-DD)
  status: AccountingPeriodStatus;
}

// Configuration types
export interface AccountingPeriodConfiguration {
  accountingPeriodAutomaticCreation: string; // "0" = manual, "1" = automatic
  fiscalYearStartDate: string; // Date string format
  accountingPeriodType?: AccountingPeriodType; // Only used in automatic mode
}

export type AccountingPeriodConfigurationRequest =
  AccountingPeriodConfiguration;

// Automatic mode execution request
export interface ExecuteAutomaticModeRequest {
  accountingType: number; // 0=None, 1=Monthly, 2=Quarterly, 3=Yearly
  fiscalStartMonth: number; // 1-12 (January=1, December=12)
}

// Metadata types
export interface AccountingPeriodMetadata {
  availableYears: number[];
  defaultYear: number;
  manualMode: {
    defaultStartDate: string; // ISO date format
    defaultEndDate: string; // ISO date format
  };
  availablePeriodTypes: string[]; // Available period types for automatic mode: ["Month", "Quarter", "Year"]
}
